import { Link } from "react-router-dom";
import { t, catLabel } from "@/lib/i18n";

export function StandardCategoryCard({ cat, index, lang }) {
  return (
    <Link
      data-testid={`category-card-${cat.slug}`}
      to={`/menu/${cat.slug}`}
      className={`group bg-[var(--card)] border border-[var(--line)] rounded-lg overflow-hidden shadow-sm hover:shadow-md hover:border-[#C5A059]/60 transition-all duration-300 animate-fade-up ${cat.slug === "cantine-siciliane" ? "col-span-2 sm:col-span-1" : ""}`}
      style={{ animationDelay: `${Math.min(index * 0.03, 0.22)}s` }}
    >
      {cat.image && (
        <div className="h-24 sm:h-28 overflow-hidden">
          <img
            src={cat.image}
            alt={cat.name}
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      )}
      <div className="px-3 py-3">
        <h3 className="font-display font-semibold text-lg text-[var(--text)] group-hover:text-[var(--bordeaux)] transition-colors leading-tight">
          {catLabel(cat.slug, lang)}
        </h3>
        <div className="mt-1.5 h-px w-8 bg-[#C5A059]/70 group-hover:w-14 transition-all duration-300" />
      </div>
    </Link>
  );
}

export function CocktailCategoryCard({ cat, lang }) {
  return (
    <Link
      data-testid={`category-card-${cat.slug}`}
      to={`/menu/${cat.slug}`}
      className="group relative rounded-xl overflow-hidden border border-[#C5A059]/35 hover:border-[#C5A059] transition-all duration-300 h-28"
    >
      <img
        src={cat.image}
        alt={cat.name}
        loading="lazy"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover opacity-60 group-hover:opacity-75 group-hover:scale-105 transition-all duration-500"
      />
      <div className="absolute inset-0 overlay-cat" />
      <div className="relative h-full flex items-center px-5">
        <div>
          <h3 className="font-display font-semibold text-2xl text-[var(--bordeaux)]">{catLabel(cat.slug, lang)}</h3>
          <span className="font-cinzel text-[10px] tracking-[0.25em] uppercase text-[#C5A059]">
            {(cat.products || []).length} {t(lang, "items")}
          </span>
        </div>
      </div>
    </Link>
  );
}
